import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

const resolveUsernameFromLink = (link: string) => {
  const replacers = [/https?:\/\/(www.)?/, /\.?t(elegram)?\.me\/?/, '@'];

  return replacers.reduce((acc: string, part) => acc.replace(part, ''), link);
};

export const getTelegramSettings = ({
  telegramLink
}: Partial<ChatsChannelBase>) => {
  if (!telegramLink) return null;

  const url = `https://t.me/${resolveUsernameFromLink(telegramLink)}`;

  return {
    provider: ChatsChannelType.telegram,
    link: { url },
    title: 'Telegram',
    icon: getChatIcon(ChatsChannelType.telegram),
    color: 'rgb(29, 152, 220)'
  } as ChatsChannelSetting;
};
